<script lang="ts" context="module">
    import qrcode from "qrcode-generator";

    import SvgA from "./SvgA.svelte";
    import { COMMIT_HASH, sfmtaUrl } from "../js/util";
</script>

<script lang="ts">
    export let stopId = "19999";
    export let stopLoc = "Somewhere";

    let stopLocLimit = null;
    $: {
        if (24 <= stopLoc.length) {
            stopLocLimit = 1095;
        }
    }

    let qrSvg = null;
    $: {
        const qr = qrcode(2, "L");
        qr.addData(sfmtaUrl(stopId, true));
        qr.make();
        qrSvg = qr.createSvgTag({ cellSize: 12, margin: 37.5 });
    }
</script>

<rect x="420" width="1180" height="230" fill="#000" />
<rect x="420" y="240" width="1180" height="135" fill="#000" />
<SvgA href={sfmtaUrl(stopId)}>
    <g transform="translate(32.5, 0)">
        {@html qrSvg}
    </g>
    <text
        class="w stop-loc"
        x="1550"
        y="105"
        textLength={stopLocLimit}
        text-anchor="end"
        lengthAdjust="spacingAndGlyphs">{stopLoc?.toUpperCase()}</text
    >
    <text class="w nextmuni" x="455" y="195">Next&hairsp;Muni?</text>
    <path
        class="w"
        transform="translate(800, 144) scale(6)"
        d="M 5.0770809,0.79882812 C 4.6733524,0.84223511 3.2073522,1.5142873 3.1630183,4.9707031 3.1165878,8.6133071 4.6713118,9.3811177 5.079034,9.3730469 l 0.00195,-2.40625 C 4.745075,6.9667489 4.6772238,6.6005449 4.6005183,5.8457031 4.5510563,5.3458594 4.5345963,4.730468 4.6005183,4.1152344 4.6481843,3.6852146 4.7269209,3.2635859 5.079034,3.2636719 Z m 0.3125,0.002775 V 3.2664469 l 0.6796874,0.00195 0.00391,-0.00195 c 0.1568385,-6e-7 0.2656215,-0.12687 0.2656213,-0.2695309 h 0.00195 c 0,0 -0.00195,-1.9295626 -0.00195,-1.9316406 -10e-8,-0.14873985 -0.1189054,-0.26367179 -0.265625,-0.26367187 z m 0.00152,6.16031838 -0.00195,2.4101563 c 0,0 0.6796867,0.002 0.6796875,0 h 0.00195 c 0.1568422,0 0.2675252,-0.1249171 0.2675781,-0.2675781 l 0.00195,-0.00391 c 0,0 -1e-5,-1.8711079 0,-1.8730469 3.7e-5,-0.1487492 -0.1208585,-0.2655702 -0.2675782,-0.265625 z"
    />
    <text class="w t511 stretch-sc" x="850" y="195">511</text>
    <text class="w t511" x="1350" y="195" text-anchor="end">
        SFMTA.com/
    </text>
    <rect x="1360" y="146.5" rx="10" width="180" height="56" fill="#fff" />
    <text class="t511" x="1449" y="195" text-anchor="middle">{stopId}</text>
</SvgA>
<g>
    <rect class="w" x="455" y="272.5" width="70" height="70" rx="5" ry="5" />
    <path
        transform="translate(455, 272.5) scale(7)"
        d="M 5.0770809,0.79882812 C 4.6733524,0.84223511 3.2073522,1.5142873 3.1630183,4.9707031 3.1165878,8.6133071 4.6713118,9.3811177 5.079034,9.3730469 l 0.00195,-2.40625 C 4.745075,6.9667489 4.6772238,6.6005449 4.6005183,5.8457031 4.5510563,5.3458594 4.5345963,4.730468 4.6005183,4.1152344 4.6481843,3.6852146 4.7269209,3.2635859 5.079034,3.2636719 Z m 0.3125,0.002775 V 3.2664469 l 0.6796874,0.00195 0.00391,-0.00195 c 0.1568385,-6e-7 0.2656215,-0.12687 0.2656213,-0.2695309 h 0.00195 c 0,0 -0.00195,-1.9295626 -0.00195,-1.9316406 -10e-8,-0.14873985 -0.1189054,-0.26367179 -0.265625,-0.26367187 z m 0.00152,6.16031838 -0.00195,2.4101563 c 0,0 0.6796867,0.002 0.6796875,0 h 0.00195 c 0.1568422,0 0.2675252,-0.1249171 0.2675781,-0.2675781 l 0.00195,-0.00391 c 0,0 -1e-5,-1.8711079 0,-1.8730469 3.7e-5,-0.1487492 -0.1208585,-0.2655702 -0.2675782,-0.265625 z"
    />
    <text class="w t311" x="540" y="335.5">311</text>
</g>
<text class="w i18n" x="690" y="295">
    中文 / Español / Français / 日本語 / 한국어 /
</text>
<text class="w i18n" x="690" y="339">
    русский / Filipino / tiếng Việt / ภาษาไทย / اللغة العربية
</text>
<path
    class="w"
    transform="translate(1450, 277.5) scale(6)"
    d="M 5,0 C 2.2439843,0 0,2.2439843 0,5 c 0,2.7562172 2.2439843,5 5,5 2.7562172,0 5,-2.2434776 5,-5 C 10,2.2439843 7.7564288,0 5,0 Z m 0,0.87694906 c 2.2821477,0 4.1227458,1.84110484 4.1227458,4.12326254 0,1.1440988 -0.4628331,2.1768697 -1.2118124,2.922819 L 6.3133097,6.3251953 H 7.1959432 V 5.1552409 H 5.1433553 L 2.0768758,2.0887614 C 2.8228351,1.3397621 3.8560927,0.87694906 5,0.87694906 Z M 5.3769328,1.5358236 c -0.3255597,0 -0.8136938,0.2892655 -0.8139038,0.8728149 0,0.3902996 0.2808669,0.7290368 0.6872965,0.8294067 0.1258499,0.03106 0.1276408,0.029163 0.1276408,0.1033529 0,0.0386 -0.0031,0.058035 -0.0031,0.096635 0,0.4154496 0.268879,0.5797343 0.5048788,0.6924642 l 0.5606893,0.00827 c 0.5935894,0.00896 0.6388195,0.014316 0.7555094,0.083716 0.06746,0.0401 0.1319584,0.1325508 0.1503784,0.2154907 0.00868,0.03911 0.01602,0.1659267 0.01602,0.2816366 0,0.1156998 0.00442,0.2144248 0.00982,0.2196248 0.00538,0.00522 0.071638,0.0093 0.1472779,0.0093 H 7.656897 V 4.6958374 C 7.656897,4.4209077 7.642365,4.3358447 7.574215,4.2059448 7.5232747,4.1088849 7.404003,3.9959826 7.3013631,3.9475627 7.1307833,3.8670927 7.1033825,3.8638051 6.5076131,3.8545451 5.8982337,3.8450651 5.8972465,3.8450957 5.8027466,3.7522257 5.7185967,3.6695258 5.6740723,3.551355 5.6740723,3.4313151 c 0,-0.1531998 0.080615,-0.2451713 0.080615,-0.3064412 0,-0.2721398 -0.7547142,0.045486 -0.885734,-0.6351034 -0.0055,-0.02854 -0.00827,-0.05781 -0.00827,-0.08785 0,-0.3071697 0.2806819,-0.5694743 0.4676717,-0.5694743 0.09339,0 0.1023194,-0.034016 0.1023194,-0.085266 v -0.084233 c 0,-0.09951 -0.00457,-0.127124 -0.053744,-0.127124 z m 0.4449341,0.2847371 c -0.00877,0 -0.01762,3.109e-4 -0.08785,0.00465 V 2.093929 c 0,1e-5 0.7064369,0.046659 0.7064169,0.6454387 -0.00146,0.3535096 -0.1803508,0.4649891 -0.1803508,0.576709 0,0.1183398 0.070296,0.1384928 0.3999756,0.1384928 0.3483896,0 0.4688244,0.018882 0.6397542,0.1002523 0.2155898,0.1026199 0.3850324,0.2996436 0.4707723,0.5472534 0.03751,0.1083599 0.039932,0.129755 0.044442,0.4480347 0.0026,0.1839198 0.011885,0.3922241 0.011885,0.3922241 0,0 0.013833,0.0062 0.1560629,0.0062 H 8.1318034 L 8.1245687,4.589384 C 8.1182787,4.2603143 8.1145502,4.218523 8.0796102,4.0912231 7.9495203,3.6174036 7.5852975,3.2773328 7.115328,3.1905029 c -0.06029,-0.01113 -0.1812843,-0.02067 -0.2692343,-0.02067 -0.1378098,0 -0.1689819,-0.00729 -0.1689819,-0.018604 0,-0.07724 0.07183,-0.1542631 0.07183,-0.3860229 0,-0.6348494 -0.5882456,-0.9446452 -0.9270749,-0.9446453 z m -4.4364218,1.1901082 2.144572,2.144572 H 1.6298747 v 1.1699544 h 3.0700968 l 2.289266,2.289266 C 6.3998581,8.9386809 5.7222509,9.1229574 5.0002116,9.1229574 c -2.2821577,0 -4.12326254,-1.8405981 -4.12326254,-4.1227458 0,-0.7220493 0.18427644,-1.4001732 0.50849604,-1.9895427 z m 5.9768962,2.144572 V 6.3251953 H 8.128186 V 5.1552409 Z"
/>
<SvgA href="https://munisign.org/{stopId}">
    <text class="footnote" x="455" y="397">
        MUNISIGN.ORG
    </text>
</SvgA>
<SvgA href="https://twitter.com/SafeStreetRebel">
    <text class="footnote" x="710" y="397">
        @SAFE<tspan dx="3">STREET</tspan><tspan dx="3">REBEL</tspan>
    </text>
</SvgA>
<SvgA href="https://48hills.org/2022/07/why-sf-needs-free-muni/">
    <text class="footnote" x="1020" y="397">
        #FREE<tspan dx="5">MUNI</tspan><tspan dx="5">FULL</tspan><tspan dx="5">SERVICE</tspan>
    </text>
</SvgA>
<SvgA href="https://github.com/MingweiSamuel/muni-sign/tree/{COMMIT_HASH}">
    <text class="footnote" x="1510" y="397" text-anchor="end">
        {new Date().toISOString().slice(0, 10).replaceAll("-", " ")}
    </text>
</SvgA>
